import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import isEmpty from 'lodash.isempty';
import useAxios from 'axios-hooks';
import uniqueId from 'lodash.uniqueid';

import { Button } from '../../../../components';

const ACRSPatientSearchModal = ({
	isOpen,
	onClose,
	providerId,
	onAddToCampaign,
}) => {
	const [{ data, loading /* error */ }, getPatientList] = useAxios(
		{
			method: 'POST',
			url: `/providers/${providerId}/acrs-patient-list2`,
		},
		{ manual: true, autoCancel: false }
	);

	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [dob, setDob] = useState('');

	const doSearch = () => {
		const filter_options = {
			record_limit: 10,
			offset: 0,
			Patient_First_Name: firstName,
			Patient_Last_Name: lastName,
			Patient_Date_of_Birth: isEmpty(dob) ? null : dob.split('-').join(''),
		};

		getPatientList({ data: { filter_options } });
	};

	const isSearchValid = !isEmpty(firstName) || !isEmpty(lastName);

	return (
		<Modal
			isOpen={isOpen}
			contentLabel="ACRS Patient Search"
			className="modal-dialog modal-xl acrs-patient-search-campaign-modal"
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">ACRS Patient Search</h3>
					</div>
				</div>
				<div className="modal-body form">
					<div className="row form-row">
						<div className="col-md-3">
							<div className="form-group">
								<label htmlFor="input-fname" className="control-label">
									First Name
								</label>
								<input
									id="input-fname"
									type="text"
									placeholder="First Name"
									className="form-control"
									onChange={({ target }) => setFirstName(target.value)}
									value={firstName}
								/>
							</div>
						</div>
						<div className="col-md-3">
							<div className="form-group">
								<label htmlFor="input-lname" className="control-label">
									Last Name
								</label>
								<input
									id="input-lname"
									type="text"
									placeholder="Last Name"
									className="form-control"
									onChange={({ target }) => setLastName(target.value)}
									value={lastName}
								/>
							</div>
						</div>
						<div className="col-md-3">
							<div className="form-group">
								<label htmlFor="input-dob" className="control-label">
									Date of Birth
								</label>
								<input
									id="input-dob"
									type="date"
									className="form-control"
									onChange={({ target }) => setDob(target.value)}
									value={dob}
								/>
							</div>
						</div>
						<div className="col-md-3">
							<div className="form-group">
								<Button
									title="Search"
									disabled={!isSearchValid || loading}
									onClick={doSearch}
									className="search-submit"
								/>
							</div>
						</div>
					</div>
					<table className="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Patient</th>
								<th>DOB</th>
								<th>Phone</th>
								<th>Address</th>
								<th>Provider</th>
								<th>Practice</th>
								<th>CC Attributes</th>
							</tr>
						</thead>
						<tbody>
							{!data && (
								<tr>
									<td colSpan="7">
										Please enter some search criteria and click Search
									</td>
								</tr>
							)}
							{data && data.length === 0 && (
								<tr>
									<td colSpan="7">No results found</td>
								</tr>
							)}
							{data &&
								data.length > 0 &&
								data.map((record) => (
									<tr key={`${uniqueId('patient-')}`}>
										<td>
											{record.patient_last_name}, {record.patient_first_name}
											{!isEmpty(record.gender) && ` ${record.gender}`}
										</td>
										<td>{record.patient_date_of_birth}</td>
										<td>
											{record.patient_phone_dash_mobile ||
												record.patient_phone_dash_home}
										</td>
										<td>
											{record.patient_address_1}{' '}
											{!isEmpty(record.patient_address_2) &&
												` ${record.patient_address_2}`}{' '}
											{record.patient_city} {record.patient_state}{' '}
											{record.patient_zip}
										</td>
										<td>
											{record.Attributed_Physician_First_Name}{' '}
											{record.Attributed_Physician_Last_Name}
										</td>
										<td>{record.Attributed_Practice_Unit_Name}</td>
										<td>
											{/* <Attribute label="PP">{record.primary_payer}</Attribute>
											<Attribute label="PPP">
												{record.primary_payer_plan}
											</Attribute>
											<Attribute label="SP">
												{record.secondary_payer}
											</Attribute>
											<Attribute label="SPP">
												{record.secondary_payer_plan}
											</Attribute>
											<Attribute label="Emp">{record.employer}</Attribute>
											<Attribute label="Loc">{record.location}</Attribute>
											<Attribute label="Prog">{record.program_1}</Attribute> */}
											<Button
												title="Add to Campaign"
												onClick={() => onAddToCampaign(record)}
												rightIcon="chevron-right"
												primary
											/>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						<Button title="Close" large onClick={onClose} />
					</div>
				</div>
			</div>
		</Modal>
	);
};
ACRSPatientSearchModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	providerId: PropTypes.number.isRequired,
	onAddToCampaign: PropTypes.func.isRequired,
};
export default ACRSPatientSearchModal;
